import React from 'react';
import cn from 'classnames';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import './styles.scss';

const Input = ({
  className,
  disableInput,
  icon,
  iconOnClick,
  value,
  inputElemProps,
  inputClassName,
  trackingId,
  inputRef,
  ...props
}) => {
  const onIconClick = () => {
    inputRef.current.focus();
    iconOnClick();
  };

  return (
    <div className={cn('autocomplete-input', className)} {...props}>
      <input
        value={value}
        disabled={disableInput}
        {...inputElemProps}
        ref={inputRef}
        className={cn(
          'border border-gray-400 rounded-24.8 text-base h-12.2 pl-4.2 pr-12.2',
          inputClassName,
          {
            'text-gray-600 bg-gray-200': disableInput,
          },
        )}
        data-tracking-id={trackingId}
      />
      {!disableInput && (
        <span
          data-test-id="autocomplete-input-expander"
          data-tracking-id={trackingId ? `${trackingId}-expander` : null}
          className="autocomplete-input__menu-icon"
          onClick={onIconClick}
        >
          {icon || (
            <Icon
              id="selectbox_arrow_down"
              accessibility={{ ariaHidden: 'true' }}
              className="text-gray-600"
            />
          )}
        </span>
      )}
    </div>
  );
};

export default Input;
